import { IMainSearchResultList } from '@/components/common/MainSearch/MainSearchResult';
import { Search } from '@/graphql/contracts/_generated_/Search.query';
import { highlightSubstring } from '@/utils/highlightSubstring';

interface InormalizeSearchResultsForComponent {
  inputData: Search['searchContractsAndCustomers'],
  searchString: string,
  handleClickContract: (res: NonNullable<Search['searchContractsAndCustomers']>['contracts'][number]) => void,
  handleClickCustomer: (res: NonNullable<Search['searchContractsAndCustomers']>['customers'][number]) => void,
}

export function normalizeSearchResultsForComponent({
  inputData,
  searchString,
  handleClickContract,
  handleClickCustomer,
}: InormalizeSearchResultsForComponent): IMainSearchResultList[] {
  const dataArr: IMainSearchResultList[] = [];

  if (inputData?.customers?.length) {
    dataArr.push({
      title: 'Customers',
      handleClick: handleClickCustomer,
      items: inputData.customers.map((el) => ({
        id: el.customerID,
        /* eslint-disable-next-line max-len */
        title: highlightSubstring(`${el.customerName} (${el.customerAccountNumber})`, searchString.trim()),
        callbackData: el,
      })),
    });
  }

  if (inputData?.contracts?.length) {
    dataArr.push({
      title: 'Contracts',
      handleClick: handleClickContract,
      items: inputData?.contracts.map((el) => ({
        id: el.contractID,
        title: highlightSubstring(el.contractNumber, searchString.trim()),
        callbackData: el,
      })),
    });
  }

  return dataArr;
}
